module.exports = __webpack_public_path__ + "img/xiaomi-1.c6c377db.png";